module.exports = __webpack_public_path__ + "static/img/アセット 29@2x.383ea4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 29@2x.png
// module id = 4DLe
// module chunks = 1